export default {
  generateLeaseReference(Customer, CustomerCompany) {
    return {
      OpdrachtnummerLease: '',
      Lessee: this.composeLessee(CustomerCompany),
      Berijder: this.composeBerijder(Customer),
      ExtraInformatie: '',
      ShowOnPdf: false,
    }
  },
  composeLessee(customerCompany) {
    return customerCompany?.CustomerCompanyMagicNumber
      ? `${customerCompany.CustomerCompanyMagicNumber} ${customerCompany.CustomerCompanyName}`
      : ''
  },
  composeBerijder(customer) {
    return customer?.CustomerMagicNumber
      ? `${customer.CustomerMagicNumber} ${this.composeCustomerName(customer)}`
      : ''
  },
  composeCustomerName(customer) {
    if (customer != null) {
      let fullName = ''

      if (customer.CustomerFirstName) {
        fullName += customer.CustomerFirstName
      } else if (customer.CustomerInitials) {
        fullName += customer.CustomerInitials
      }

      const middleName = customer.CustomerMiddleName || ''
      if (middleName !== '') {
        fullName = fullName.concat(' ', middleName)
      }
      const familyName = customer.CustomerFamilyName || ''
      return fullName.concat(' ', familyName)
    } else return ''
  },
}
